
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export const useDeleteMaterial = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (materialId: string) => {
      // `.select()` fa tornare le righe effettivamente cancellate: se la RLS blocca
      // (es. materiale del catalogo globale, organization_id NULL) PostgREST risponde
      // comunque 204 SENZA errore ma cancella 0 righe. Senza questo controllo la UI
      // mostrerebbe un falso "eliminato con successo" mentre la riga resta.
      const { data, error } = await supabase
        .from('materials')
        .delete()
        .eq('id', materialId)
        .select('id');

      if (error) {
        throw new Error(`Error deleting material: ${error.message}`);
      }
      if (!data || data.length === 0) {
        throw new Error(
          'Materiale non eliminato: appartiene al catalogo condiviso o non hai i permessi per eliminarlo.'
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['materials'] });
    },
  });
};
